<template>
    <client-page className="header--light">
        <sub-visual sh="위치안내" tabActive="위치안내" bg="/images/sub/visual/sv5.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <div class="border pa-20 pa-md-30 pa-lg-50 mb-50 mb-lg-100 cap-wrap">
                    <div class="w-100" data-aos="zoom-in-up">
                        <v-img src="/images/sub/location/map.png" max-width="580" contain class="mx-auto"></v-img>
                        <!-- <p class="cap page-text--sm color-grey-c7 text-right line-height-1">*2022년 12월 기준</p> -->
                    </div>
                </div>

                <v-row class="ma-xl-n30">
                    <template v-for="(item, index) in items">
                        <v-col :key="index" cols="12" md="6" class="pa-xl-30">
                            <location :tit="item.tit" :address="item.address" :tel="item.tel" :mapImage="item.mapImage" :link="item.link" />
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import Location from "@/components/client/sub/sub-location.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        Location,
    },
    data: () => ({
        items: [
            {
                tit: "본사",
                address: "서울시 서초구 강남대로 186 4층",
                tel: "1600-3939",
                mapImage: "/images/sub/location/head.jpg",
                link: "https://naver.me/FAP69fXn",
            },
            {
                tit: "신도림 지점",
                address: "서울시 영등포구 도영로 19 삼영빌딩 4층",
                tel: "02-843-2300",
                mapImage: "/images/sub/location/map2.jpg",
                link: "https://naver.me/FZ2Ei0Ez",
            },
            {
                tit: "왕십리 지점",
                address: "서울시 성동구 왕십리로 353 VIP빌딩 4,5,6층",
                tel: "02-2281-1707",
                mapImage: "/images/sub/location/map3.jpg",
                link: "https://naver.me/5VmFbXzl",
            },
            {
                tit: "홍대 지점",
                address: "서울특별시 마포구 동교로23길 14 국제빌딩 4층",
                tel: "02-6352-9021",
                mapImage: "/images/sub/location/map4.jpg",
                link: "https://naver.me/x2jl1Ho1",
            },
            {
                tit: "사당 지점",
                address: "서울시 동작구 동작대로 1길 10-14 새롬빌딩 5층,6층",
                tel: "02-3789-7006",
                mapImage: "/images/sub/location/map5.jpg",
                link: "https://naver.me/G7Vnq742",
            },
            {
                tit: "잠실 지점",
                address: "서울시 송파구 올림픽로 240 롯데웰빙센터 2층 215호",
                tel: "042-361-6046",
                mapImage: "/images/sub/location/map13.jpg",
                link: "https://naver.me/5h3TZs0V",
            },
            {
                tit: "인천 지점",
                address: "인천광역시 부평구 경인로 954-1 경인스타빌딩 3층",
                tel: "032-262-2305",
                mapImage: "/images/sub/location/map6.jpg",
                link: "https://naver.me/5duS0UhH",
            },
            {
                tit: "수원 지점",
                address: "경기도 수원시 팔달구 인계로 130 더스퀘어빌딩 4층",
                tel: "031-890-5592",
                mapImage: "/images/sub/location/map7.jpg",
                link: "https://naver.me/5fIZtAiu",
            },
            {
                tit: "고양 지점",
                address: "경기도 고양시 일산동구 중앙로1261번길 77 메트로폴리스 404호",
                tel: "031-932-9130",
                mapImage: "/images/sub/location/goyang.jpg",
                link: "https://naver.me/GBvqeyVC",
            },
            {
                tit: "대전 지점",
                address: "대전광역시 서구 문예로 11, 소천빌딩 8층",
                tel: "042-487-2300",
                mapImage: "/images/sub/location/map8.jpg",
                link: "https://naver.me/FpxW24p8",
            },
            {
                tit: "대구 지점",
                address: "대구광역시 남구 중앙대로 199-2 중앙타워 3층",
                tel: "053-213-3150",
                mapImage: "/images/sub/location/map9.jpg",
                link: "https://naver.me/GEXMGekQ",
            },
            {
                tit: "부산 지점",
                address: "부산광역시 부산진구 중앙대로 749 범향빌딩 12층",
                tel: "051-808-0037",
                mapImage: "/images/sub/location/busan.jpg",
                link: "https://naver.me/5OQfILZ8",
            },
            {
                tit: "제주 지점",
                address: "제주시 서광로 291 3층",
                tel: "064-900-0052",
                mapImage: "/images/sub/location/map12.jpg",
                link: "https://naver.me/xrSnuYUh",
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.cap-wrap {
    position: relative;
}
.cap {
    position: absolute;
    bottom: 20px;
    right: 20px;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .cap {
        bottom: 40px;
        right: 40px;
    }
}
@media (min-width: 1200px) {
}
</style>